import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import Swal, {SweetAlertIcon} from 'sweetalert2';
import { environment } from "../../../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class AlertMessageService {

    constructor(private translate: TranslateService,
                private router: Router) {
    }

    public showSessionOff(): void {
        Swal.fire({
            title: this.translate.instant('GENERAL.ON_SESSION_EXPIRED_TITLE'),
            text: this.translate.instant('GENERAL.ON_SESSION_EXPIRED_MESSAGE'),
            icon: 'error',
            allowEscapeKey: false,
            allowOutsideClick: false,
            allowEnterKey: false,
            confirmButtonColor: environment.primaryColor,
        }).then((result) => {
            if (result.value) {
                this.router.navigate(['/login']);
            }
        });
    }

    // @ts-ignore
  public  showQuestion(title: string, message: string, btnOk: string = null, btnCancel: string = null) {
        return Swal.fire({
            titleText: title,
            text: message,
            icon: 'question',
            allowEscapeKey: false,
            allowEnterKey: true,
            showCancelButton: true,
            confirmButtonColor: environment.primaryColor,
            confirmButtonText: (!btnOk) ? this.translate.instant('GENERAL.YES') : btnOk,
            cancelButtonText: (!btnCancel) ? this.translate.instant('GENERAL.NO') : btnCancel
        });
    }

    // @ts-ignore
  public showMessageError(message: string, title: string = null) {
        return this.showMessage(
            (!title) ? this.translate.instant('GENERAL.ERRORS.AN_ERROR_HAS_OCCURRED') : title,
            message,
            'error'
        );
    }

  public  showErrorWhenSave() {
        return this.showMessageError(this.translate.instant('GENERAL.ERRORS.AN_ERROR_WHEN_SAVED'));
    }

  public showSuccessSave() {
        // @ts-ignore
      return this.showMessage(null,
            this.translate.instant('GENERAL.ON_REGISTERED_SUCCESSFULLY'),
            'success');
    }


  public showLimitLicenseUser() {
        return this.showMessageError(
            this.translate.instant('USERS.ERRORS.LIMIT_USER_REPRESENTATIVE_MESSAGE'),
            this.translate.instant('USERS.ERRORS.LIMIT_USER_REPRESENTATIVE'),
        );
    }

  public showLockWhenDelete() {
        return this.showMessageError(
            this.translate.instant('GENERAL.AN_LOCK_WHEN_DELETED'),
            this.translate.instant('GENERAL.WARNING')
        );
    }

  public  showCompanySelected() {
        return this.showMessageError(
            this.translate.instant('COMPANIES.ERRORS.COMPANY_SELECTED'),
            this.translate.instant('GENERAL.WARNING')
        );
    }

    // @ts-ignore
  public showMessage(title: string, message: string, typeMessage: SweetAlertIcon = 'info', buttonOk: string = null) {
        return Swal.fire({
            titleText: title,
            html: message,
            icon: typeMessage,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonColor: environment.primaryColor,
            confirmButtonText: (!buttonOk) ? this.translate.instant('GENERAL.OK') : buttonOk
        });
    }
}
